import produce from 'immer';
import { SHOW, HIDE } from './actions';

const initialState = {
  modalType: null,
  modalProps: {},
};

export type ModalStateType = typeof initialState;

export default produce((draft: ModalStateType, action) => {
  switch (action.type) {
    case SHOW:
      draft.modalType = action.modalType;
      draft.modalProps = action.modalProps;
      break;
    case HIDE:
      return initialState;
    default:
    // nothing
  }
}, initialState);
